module.exports = __webpack_public_path__ + "img/a-ziyuan5.1161ef21.png";